/** Outcome of `GET …/whatsapp-exists` after loading. */
export type WhatsAppExistsStatus = 'yes' | 'no' | 'unconfigured' | 'error';

export type WhatsAppExistsPayload = {
  exists?: boolean | null;
  configured?: boolean;
};

/** Map API payload — never conflate gateway-off with “number not on WhatsApp”. */
export function mapWhatsAppExistsPayload(
  data: WhatsAppExistsPayload | null | undefined,
): WhatsAppExistsStatus {
  if (!data) return 'error';
  if (data.configured === false) return 'unconfigured';
  if (data.exists === true) return 'yes';
  if (data.exists === false) return 'no';
  return 'error';
}

export function whatsAppExistsStatusLabel(status: WhatsAppExistsStatus): string {
  switch (status) {
    case 'yes':
      return 'Numéro joignable sur WhatsApp.';
    case 'no':
      return 'Numéro non enregistré sur WhatsApp.';
    case 'unconfigured':
      return 'WhatsApp non configuré sur cet environnement.';
    case 'error':
      return 'Vérification WhatsApp indisponible.';
  }
}
